import { api } from "./api";

export const unitsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUnits: builder.query({
      query: () => "api/Stock/Units",
      providesTags: ["units"],
    }),
    addUnit: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Units",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["units"],
    }),
    editUnit: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Units",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["units"],
    }),
    deleteUnit: builder.mutation({
      query: (unitId) => ({
        url: `api/Stock/Units?UnitID=${unitId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["units"],
    }),
  }),
});

export const {
  useGetUnitsQuery,
  useAddUnitMutation,
  useEditUnitMutation,
  useDeleteUnitMutation,
} = unitsApi;
